module.exports = __webpack_public_path__ + "img/5_41.0b93c7b3.png";